import { useCreation } from '@psl/functions/hooks/useCreation';
import {
  createContext,
  memo,
  MutableRefObject,
  ReactNode,
  useRef,
} from 'react';
import { BehaviorSubject } from 'rxjs';

type ContinuousOnboardingPresenterProps = {
  presentedPostIds$: BehaviorSubject<string[]>;
  paused: MutableRefObject<boolean>;
};

export const ContinuousOnboardingPresenterContext =
  createContext<ContinuousOnboardingPresenterProps>(null as any);

export const ContinuousOnboardingPresenterProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    const paused = useRef<boolean>(false);
    const presentedPostIds$ = useCreation(
      () => new BehaviorSubject<string[]>([]),
      [],
    );
    return (
      <ContinuousOnboardingPresenterContext.Provider
        value={{ presentedPostIds$, paused }}
      >
        {children}
      </ContinuousOnboardingPresenterContext.Provider>
    );
  },
);
